import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import type { KVScreenshotResult } from 'types'

import { KVMessageDef } from './index'

export function getPoseScreenshotResultMessage() {
  return {
    type: 'poseScreenshotResult',
    requiredData: [
      'requestId',
      'success',
      'width',
      'height',
      'position',
      'rotation',
      'imageBase64',
    ],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      // Log the raw message received from the screenshot tool
      // This may include a large base64 payload
      // eslint-disable-next-line no-console
      console.log('[Kestrel] poseScreenshotResult message:', json)
      if (!kv.setScreenshotResult) return

      const result: KVScreenshotResult = {
        requestId: json.requestId as string,
        success: Boolean(json.success),
        width: json.width as number,
        height: json.height as number,
        position: json.position as string,
        rotation: json.rotation as string,
        imageBase64: json.imageBase64 as string,
      }

      kv.setScreenshotResult(result)
    },
  } as KVMessageDef
}
